import Cookies from "js-cookie";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { whoami, whoamiQueryKey } from "@/auth/whoami.service";
import { signOut } from "aws-amplify/auth";
import { toast } from "sonner";
import { cn } from "@/lib/utils";
import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/app-sidebar";
import { CommandMenu } from "@/components/command-menu";
import { adminSidebarData } from "@/components/layout/data/admin-sidebar-data";

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: async ({ context: { queryClient } }) => {
    try {
      await queryClient.fetchQuery({
        queryKey: whoamiQueryKey,
        queryFn: whoami,
      });
    } catch (_) {
      await signOut();
      toast.error("Unauthorized. Please login again.");
      // return redirect({
      //   to: '/sign-in-2',
      // })
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const defaultOpen = Cookies.get("sidebar:state") !== "false";
  return (
    <SidebarProvider defaultOpen={defaultOpen}>
      <AppSidebar sidebarData={adminSidebarData} />
      <CommandMenu sidebarData={adminSidebarData} />
      <div
        id="content"
        className={cn(
          "ml-auto w-full max-w-full",
          "peer-data-[state=collapsed]:w-[calc(100%-var(--sidebar-width-icon)-1rem)]",
          "peer-data-[state=expanded]:w-[calc(100%-var(--sidebar-width))]",
          "transition-[width] duration-200 ease-linear",
          "flex h-svh flex-col",
          "group-data-[scroll-locked=1]/body:h-full",
          "group-data-[scroll-locked=1]/body:has-[main.fixed-main]:h-svh",
        )}
      >
        <Outlet />
      </div>
    </SidebarProvider>
  );
}
